module.exports = __webpack_public_path__ + "static/media/1.fa68ee7f.svg";